import React, { useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import Column from 'components/common/Column';
import CommonImage from 'components/common/CommonImage';
import Row from 'components/common/Row';
import { ICON_CLOSE, ICON_NOTICE_BLUE } from 'assets/icons';
import Text from 'components/common/Text';
import { SettlementsNode } from 'containers/SettlementRequest/graphQL/types';
import BasicButton from 'components/Button/BasicButton';
import Divider from 'components/Divider';

const InformationBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 8px;

  border-radius: 8px;
  background: #f4f4f5;
`;

interface SettlementListRequestModalIProps {
  isMobile: boolean;
  selectedSettlement: SettlementsNode[];
  onClose: () => void;
  handleRequestInvoices: (
    settlementIds: string[],
    callback: () => void,
  ) => void;
  refetchSettlementList: () => void;
}

const SettlementListRequestModal: React.FC<
  SettlementListRequestModalIProps
> = props => {
  const {
    isMobile,
    selectedSettlement,
    onClose,
    handleRequestInvoices,
    refetchSettlementList,
  } = props;

  const [showDetailSettlement, setShowDetailSettlement] =
    useState<boolean>(false);

  const isMinusSettlement = (): boolean => {
    let price: number = 0;

    selectedSettlement.filter(
      item => Number(item.totalPayment.value) + Number(item.totalFee.value) < 0,
    );

    return price >= 0;
  };

  const formatTotalPrice = (): string => {
    let price: number = 0;

    selectedSettlement.filter(
      item =>
        (price +=
          Number(item.totalFee.value) + Number(item.totalPayment.value)),
    );

    return price.toLocaleString();
  };

  const formatTotalFee = (): string => {
    let fee: number = 0;

    selectedSettlement.filter(item => (fee += Number(item.totalFee.value)));

    return fee.toLocaleString();
  };

  const formatTotalPayment = (): string => {
    let payment: number = 0;

    selectedSettlement.filter(
      item => (payment += Number(item.totalPayment.value)),
    );

    return payment.toLocaleString();
  };

  const renderInvoiceItem = (
    title: string,
    value: string | React.ReactElement,
  ): JSX.Element => {
    return (
      <Row justifyContent="space-between" style={{ width: '100%' }}>
        <Text color="#46474C">{title}</Text>
        <Text color="#1B1C1E" weight={400}>
          {value}
        </Text>
      </Row>
    );
  };

  const renderSettlement = (settlement: SettlementsNode): JSX.Element => {
    return (
      <Column gap="16px" align="flex-start">
        <InformationBadge>
          <Text color="#1b1c1e" size="12px">
            {settlement.title.slice(6)}
          </Text>
        </InformationBadge>
        <Column gap="12px">
          {renderInvoiceItem(
            '정산 기간',
            `${dayjs(settlement.startedDate).format(
              'YYYY년 MM월 DD일',
            )}~${dayjs(settlement.endedDate).format('YYYY년 MM월 DD일')}`,
          )}
          {renderInvoiceItem(
            '수입',

            `${(
              Number(settlement.totalPayment.value) +
              Number(settlement.totalFee.value)
            ).toLocaleString()}원`,
          )}
          {renderInvoiceItem(
            '플랫폼 수수료',
            `${Number(settlement.totalFee.value).toLocaleString()}원`,
          )}
          <Row justifyContent="space-between" style={{ width: '100%' }}>
            <Text color="#1b1c1e" size="16px" weight={600}>
              지급 금액
            </Text>
            <Text color="#1B1C1E" size="16px" weight={600}>
              {Number(settlement.totalPayment.value).toLocaleString()}원
            </Text>
          </Row>
        </Column>
      </Column>
    );
  };

  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      onCloseText=" "
      onClose={() => {}}
      onAcceptText="네, 요청할게요"
      onClick={() => {
        handleRequestInvoices(
          selectedSettlement.map(item => item.id),
          () => {
            onClose();

            refetchSettlementList();
          },
        );
      }}
      buttonStyle={{ padding: '12px 24px' }}
    >
      <Column style={{ padding: '0 20px' }}>
        <Row
          style={{
            position: 'sticky',
            top: '0',
            padding: '16px 0',
            width: '100%',
            background: '#fff',
          }}
        >
          <CommonImage
            src={ICON_CLOSE}
            onClick={onClose}
            style={{ position: 'absolute', left: '0px' }}
          />
          <Text color="#000" size="16px" weight={600}>
            일괄 지급을 요청할까요?
          </Text>
        </Row>
        <Column gap="24px" style={{ padding: '20px 0' }} align="flex-start">
          <Row
            gap="8px"
            justifyContent="flex-start"
            style={{ flexWrap: 'wrap' }}
          >
            {selectedSettlement.map((item, idx) => {
              return (
                <InformationBadge key={idx}>
                  <Text color="#1b1c1e" size="12px">
                    {item.title.slice(6)}
                  </Text>
                </InformationBadge>
              );
            })}
          </Row>
          <Column
            gap="16px"
            style={{
              padding: '16px',
              borderRadius: '12px',
              background: '#f7f7f8',
            }}
          >
            <Column gap="12px">
              <Row justifyContent="space-between" style={{ width: '100%' }}>
                <Text color="#46474C" size="14px">
                  총수입
                </Text>
                <Text
                  color={!isMinusSettlement() ? '#ff4242' : '#70737C'}
                  size="16px"
                  weight={400}
                >
                  {formatTotalPrice()}원
                </Text>
              </Row>
              <Row justifyContent="space-between" style={{ width: '100%' }}>
                <Text color="#46474C" size="14px">
                  플랫폼 수수료
                </Text>
                <Text
                  color={!isMinusSettlement() ? '#ff4242' : '#70737C'}
                  size="16px"
                  weight={400}
                >
                  {formatTotalFee()}원
                </Text>
              </Row>
            </Column>
            <Row justifyContent="space-between" style={{ width: '100%' }}>
              <Text color="#1b1c1e" size="16px" weight={600}>
                지급 예정 금액
              </Text>
              <Text
                color={!isMinusSettlement() ? '#FF4242' : '#1b1c1e'}
                size="16px"
                weight={600}
              >
                {formatTotalPayment()}원
              </Text>
            </Row>
          </Column>
          {showDetailSettlement ? (
            <React.Fragment>
              <Divider />
              {selectedSettlement.map((item, idx) => {
                return (
                  <React.Fragment key={idx}>
                    {renderSettlement(item)}
                    {selectedSettlement.length !== idx + 1 && <Divider />}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ) : (
            <BasicButton
              content="회차별 정산 내역 확인"
              style={{ width: '100%', borderRadius: '8px' }}
              onClick={() => setShowDetailSettlement(true)}
            />
          )}
          <InformationBadge style={{ padding: '14px 12px', width: '100%' }}>
            <Row
              gap="6px"
              justifyContent="flex-start"
              style={{ width: '100%' }}
            >
              <CommonImage
                src={ICON_NOTICE_BLUE}
                onClick={() => {}}
                style={{ width: '16px' }}
              />
              <Text color="#46474C" size="13px">
                {/* 요청 시 일반적으로 가까운 수요일 날짜에 정산금이 지급됩니다. */}
                요청 시 일반적으로 가까운 목요일 날짜에 정산금이
                지급됩니다.(공휴일에는 다음 영업일에 진행)
              </Text>
            </Row>
          </InformationBadge>
        </Column>
      </Column>
    </ModalContainer>
  );
};

export default SettlementListRequestModal;
